import { Lease } from "./lease.model"
import { Owner } from "./owner.model"
import { Tenant } from "./tenant.model"

export interface Payment {
  id?: string
  leaseId?: string
  lease?: Lease
  tenantId?: string
  tenant?: Tenant
  ownerId?: string
  owner?: Owner
  amount?: number
  paymentFrequency?: string
  paymentDate?: string // ISO date string
  expiresAt?: string
  paymentMethod?: string
  filename?: string
  file?: any
  minioFile?: string
  receipt?: any
  minioReceipt?: string
  receiptFilename?: string
  fsNumber?: string
  paymentStatus?: PaymentStatus
  paymentType?: string
  archiveReason?: string
  createdBy?: string
  updatedBy?: string
  createdAt?: string
  updatedAt?: string
  deletedAt?: string
  deletedBy?: string
}

export enum PaymentStatus {
  Pending = "Pending",
  Success = "Success",
  Failed = "Failed",
  Expired = "Expired",
  Rejected = "Rejected",
}
